import PropTypes from 'prop-types'
import ActiveRecord from 'model/activeRecord'
import { isNil } from 'ramda'

class ThirdPartyAdmin extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> ThirdPartyAdmin constructor -', init)
    if (isNil(init)) return undefined
    this._abbr = init.abbr
    this._name = init.name
    this._notes = init.notes
  }

  static shape = {
    id: PropTypes.string.isRequired,
    abbr: PropTypes.string,
    name: PropTypes.string,
    notes: PropTypes.string
  }

  get abbr() {
    return this._abbr
  }

  get name() {
    return this._name
  }

  get notes() {
    return this._notes
  }
}

export default ThirdPartyAdmin
